// proto/v2/search/search.proto

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file search/search.proto (package lvdr.v2.search, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PaginationParams } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file search/search.proto.
 */
export const file_search_search: GenFile = /*@__PURE__*/
  fileDesc("ChNzZWFyY2gvc2VhcmNoLnByb3RvEg5sdmRyLnYyLnNlYXJjaCJ0Cg1TZWFyY2hSZXF1ZXN0Eg0KBXF1ZXJ5GAEgASgJEg8KB2RvbWFpbnMYAiADKAkSDQoFbGltaXQYAyABKAUSNAoKcGFnaW5hdGlvbhgEIAEoCzIgLmx2ZHIudjIuY29tbW9uLlBhZ2luYXRpb25QYXJhbXMiXQoOU2VhcmNoUmVzcG9uc2USJwoEaGl0cxgBIAMoCzIZLmx2ZHIudjIuc2VhcmNoLlNlYXJjaEhpdBINCgV0b3RhbBgCIAEoBRITCgtuZXh0X2N1cnNvchgDIAEoCSJWCglTZWFyY2hIaXQSDgoGZG9tYWluGAEgASgJEgoKAmlkGAIgASgJEg0KBXRpdGxlGAMgASgJEg8KB2V4Y2VycHQYBCABKAkSDQoFc2NvcmUYBSABKAFCJ1olZ2l0aHViLmNvbS9ndnM0Mi9sdmRyL3Byb3RvL3YyL3NlYXJjaGIGcHJvdG8z", [file_common_common]);

/**
 * Requests
 *
 * @generated from message lvdr.v2.search.SearchRequest
 */
export type SearchRequest = Message<"lvdr.v2.search.SearchRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: repeated string domains = 2;
   */
  domains: string[];

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: lvdr.v2.common.PaginationParams pagination = 4;
   */
  pagination?: PaginationParams | undefined;
};

/**
 * Describes the message lvdr.v2.search.SearchRequest.
 * Use `create(SearchRequestSchema)` to create a new message.
 */
export const SearchRequestSchema: GenMessage<SearchRequest> = /*@__PURE__*/
  messageDesc(file_search_search, 0);

/**
 * Responses
 *
 * @generated from message lvdr.v2.search.SearchResponse
 */
export type SearchResponse = Message<"lvdr.v2.search.SearchResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.search.SearchHit hits = 1;
   */
  hits: SearchHit[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: string next_cursor = 3;
   */
  nextCursor: string;
};

/**
 * Describes the message lvdr.v2.search.SearchResponse.
 * Use `create(SearchResponseSchema)` to create a new message.
 */
export const SearchResponseSchema: GenMessage<SearchResponse> = /*@__PURE__*/
  messageDesc(file_search_search, 1);

/**
 * @generated from message lvdr.v2.search.SearchHit
 */
export type SearchHit = Message<"lvdr.v2.search.SearchHit"> & {
  /**
   * @generated from field: string domain = 1;
   */
  domain: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string excerpt = 4;
   */
  excerpt: string;

  /**
   * @generated from field: double score = 5;
   */
  score: number;
};

/**
 * Describes the message lvdr.v2.search.SearchHit.
 * Use `create(SearchHitSchema)` to create a new message.
 */
export const SearchHitSchema: GenMessage<SearchHit> = /*@__PURE__*/
  messageDesc(file_search_search, 2);

